<template>
  <div>
    <div class="d-flex justify-content-end">
      <b-dropdown v-if="pagination && pagination.docs.length" split split-href="#" :text="$t('common.download-options')" size="sm" variant="light" class="mr-2 ">
        <b-dropdown-item @click="downloadExcel" href="#">{{ $t("common.download") }}</b-dropdown-item>
      </b-dropdown>

      <right-panel class="float-right" id="sidebar-new-firm" width="600px" :icon="'mdi mdi-plus'" @hidden="rightPanelClosed">
        <div class="pl-5 pr-5">
          <Form />
        </div>
      </right-panel>

      <sweet-button class="mr-4" v-b-modal="'sidebar-new-firm'" @click="toggleForm" variant="link" icon="bx bx-plus" size="sm" buttonClass=" text-white btn-main">
        {{ $t("firm.new") }}
      </sweet-button>
    </div>

    <h2>{{ $t("firm.plural") }}</h2>
    <div class="table-responsive">
      <table class="table project-list-table compact">
        <thead>
          <tr class="">
            <th style="width:300px">{{ $t("firm.name") }}</th>
            <th style="width:150px">{{ $t("firm.vkn") }}</th>
            <th style="width:300px">{{ $t("firm.admin.name") }}</th>
            <th style="width:300px">{{ $t("firm.admin.email") }}</th>
            <th style="width:300px">{{ $t("firm.admin.phone") }}</th>
            <th style="width:300px">{{ $t("firm.unit-admin-name") }}</th>
            <th style="width:200px">{{ $t("firm.application-date") }}</th>
            <th style="width:300px">{{ $t("firm.context") }}</th>
            <th style="width:300px">{{ $t("firm.support-service") }}</th>
            <th style="width:300px">{{ $t("firm.virtual-server") }}</th>
            <th style="width:250px">{{ $t("firm.status.text") }}</th>

            <th style="width: 30px">
              <a href="javascript:;" @click="toggleFilter">
                <span v-if="filterEnabled" class="text-warning">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-hide") }}
                </span>
                <span v-else class="text-muted">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-show") }}
                </span>
              </a>
            </th>
          </tr>
          <tr v-if="filterEnabled">
            <th><input class="form-control " v-model="nameFilter" :placeholder="$t('firm.name')" /></th>
            <th><input class="form-control " v-model="vknFilter" :placeholder="$t('firm.vkn')" /></th>
            <th><input class="form-control " v-model="adminNameFilter" :placeholder="$t('firm.admin.name')" /></th>
            <th><input class="form-control " v-model="adminEmailFilter" :placeholder="$t('firm.admin.email')" /></th>
            <th><input class="form-control " v-model="adminPhoneFilter" :placeholder="$t('firm.admin.phone')" /></th>
            <th><input class="form-control " v-model="unitAdminNameFilter" :placeholder="$t('firm.unit-admin-name')" /></th>
            <th>
              <date-picker v-model="applicationDateFilter" :first-day-of-week="1" lang="tr" format="DD.MM.YYYY" value-type="timestamp" placeholder="Örn: 21.11.2020" />
            </th>
            <th><input class="form-control " v-model="descriptionFilter" :placeholder="$t('firm.context')" /></th>
            <th>
              <select class="form-control" v-model="supportServiceFilter">
                <option :value="undefined">{{ $t("common.clear-selection") }}</option>
                <option :value="true">{{ $t("common.yes") }}</option>
                <option :value="false">{{ $t("common.no") }}</option>
              </select>
            </th>
            <th>
              <select class="form-control" v-model="virtualServerFilter">
                <option :value="undefined">{{ $t("common.clear-selection") }}</option>
                <option :value="true">{{ $t("common.yes") }}</option>
                <option :value="false">{{ $t("common.no") }}</option>
              </select>
            </th>

            <th>
              <select class="form-control" v-model="statusFilter">
                <option :value="undefined">{{ $t("common.clear-selection") }}</option>

                <option value="REVIEW">{{ $t("firm.status.review") }}</option>
                <option value="PRE_TEST">{{ $t("firm.status.pre-test") }}</option>
                <option value="TEST">{{ $t("firm.status.test") }}</option>
                <option value="PRE_PROD">{{ $t("firm.status.pre-prod") }}</option>
                <option value="PROD">{{ $t("firm.status.prod") }}</option>
                <option value="CANCELED">{{ $t("firm.status.canceled") }}</option>
              </select>
            </th>
          </tr>
        </thead>
        <template v-if="pagination && pagination.docs.length > 0">
          <tr v-for="item in pagination.docs" :key="item._id" class="hider">
            <td>{{ item.name | translate }}</td>

            <td>{{ item.vkn | translate }}</td>

            <td>
              <span v-if="item.admin">{{ item.admin.name }}</span>
            </td>

            <td>
              <span v-if="item.admin">{{ item.admin.credential.email }}</span>
            </td>
            <td>
              <span v-if="item.admin">{{ item.admin.phone }}</span>
            </td>

            <td>
              <span>{{ item.unitAdminName | translate }}</span>
            </td>

            <td>
              <span>{{ item.applicationDate | date }}</span>
            </td>
            <td>
              <span>{{ item.description | translate }}</span>
            </td>
            <td>
              <span>{{ item.supportService ? $t("common.yes") : $t("common.no") }}</span>
            </td>

            <td>{{ item.virtualServer ? $t("common.yes") : $t("common.no") }}</td>

            <td><firm-status :status="item.status" /></td>

            <td>
              <div class="hidden hand">
                <a @click="openInviteModal(item)" v-b-tooltip.hover :title="$t('firm.admin.invite')" class="mr-2">
                  <i class="bx bx-envelope text-success"></i>
                </a>
                <a @click="edit(item)" v-b-toggle="'sidebar-edit-organization-datasource'" v-b-tooltip.hover :title="$t('common.edit')" class="mr-2">
                  <i class="bx bx-pencil text-primary"></i>
                </a>

                <a @click="deleteById(item)" v-b-tooltip.hover :title="$t('common.delete')">
                  <i class="bx bx-trash-alt text-danger"></i>
                </a>
              </div>
            </td>
          </tr>
        </template>
      </table>
    </div>
    <!-- end row -->

    <content-loading v-if="isLoading" />

    <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)">
      <h5 class="text-center">
        {{ $t("common.empty") }}
      </h5>
    </empty>

    <!-- Begin: Pagination -->

    <div v-if="pagination" class="row mb-5 pb-5">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <div class="mb-5 mt-5 pt-5 pb-5"></div>
    <!-- End: Pagination -->

    <b-modal hide-footer id="invite-firm-admin-modal" :title="$t('firm.admin.invite')" @hidden="selectedFirmForInvite = undefined">
      <firm-admin-invite v-if="selectedFirmForInvite" :firm="selectedFirmForInvite" @success="handleInviteSuccess" />
    </b-modal>
  </div>
</template>

<script>
import Modal from "@c/modal.vue";
import FirmStatus from "@cc/firm-status";
import FirmStatusSelect from "@cc/firm-status-select";
import DatePicker from "vue2-datepicker";
import FirmAdminInvite from "./firm-admin-invite.vue";
import Form from "./organization-firm-form";
export default {
  components: { Form, FirmAdminInvite, Modal, FirmStatus, FirmStatusSelect, DatePicker },
  data() {
    return {
      request: {
        options: { page: 1, limit: 15, sort: { name: "asc" } },
        query: {},
      },

      nameFilter: undefined,
      vknFilter: undefined,
      statusFilter: undefined,
      adminNameFilter: undefined,
      adminEmailFilter: undefined,
      adminPhoneFilter: undefined,
      unitAdminNameFilter: undefined,
      applicationDateFilter: undefined,
      descriptionFilter: undefined,
      supportServiceFilter: undefined,
      virtualServerFilter: undefined,
      filterEnabled: false,
      selectedFirmForInvite: undefined,
    };
  },
  computed: {
    selectedEntity() {
      return this.$store.getters["organizationFirm/selectedEntity"];
    },
    pagination() {
      return this.$store.getters["organizationFirm/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationFirm/isLoading"];
    },
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },

    nameFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
    vknFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, vkn: { value: n } };
      } else {
        this.request.query["vkn"] = null;
        delete this.request.query["vkn"];
      }
    },
    statusFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, status: { value: n, isObject: true } };
      } else {
        this.request.query["status"] = null;
        delete this.request.query["status"];
      }
    },
    adminNameFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, adminName: { value: n } };
      } else {
        this.request.query["adminName"] = null;
        delete this.request.query["adminName"];
      }
    },
    adminEmailFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, adminEmail: { value: n } };
      } else {
        this.request.query["adminEmail"] = null;
        delete this.request.query["adminEmail"];
      }
    },
    adminPhoneFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, adminPhone: { value: n } };
      } else {
        this.request.query["adminPhone"] = null;
        delete this.request.query["adminPhone"];
      }
    },
    unitAdminNameFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, unitAdminName: { value: n } };
      } else {
        this.request.query["unitAdminName"] = null;
        delete this.request.query["unitAdminName"];
      }
    },
    applicationDateFilter(n, o) {
      if (!n) {
        this.request.query = { ...this.request.query, applicationDate: undefined };
        return;
      }
      this.request.query = { ...this.request.query, applicationDate: { value: n, isObject: true } };
    },
    descriptionFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, description: { value: n } };
      } else {
        this.request.query["description"] = null;
        delete this.request.query["description"];
      }
    },
    supportServiceFilter(n, o) {
      if (n !== null && n !== undefined) {
        this.request.query = {
          ...this.request.query,
          supportService: { value: n, isObject: true },
        };
      } else {
        this.request.query["supportService"] = null;
        delete this.request.query.supportService;
      }
    },

    virtualServerFilter(n, o) {
      if (n !== null && n !== undefined) {
        this.request.query = {
          ...this.request.query,
          virtualServer: { value: n, isObject: true },
        };
      } else {
        this.request.query["virtualServer"] = null;

        delete this.request.query.virtualServer;
      }
    },
  },
  mounted() {},
  methods: {
    toggleForm() {
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-firm");
    },
    openInviteModal(firm) {
      this.selectedFirmForInvite = firm;
      this.$bvModal.show("invite-firm-admin-modal");
    },
    handleInviteSuccess() {
      this.$bvModal.hide("invite-firm-admin-modal");
      this.paginate();
    },
    async paginate() {
      await this.$store.dispatch("organizationFirm/paginate", this.request);
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationFirm/delete", item._id);
        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' Silindi");
        this.paginate();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: "'" + this.$options.filters.translate(item.name) + "' Silinemedi" });
      }
    },

    edit(item) {
      this.$store.commit("organizationFirm/editedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-firm");
    },

    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;

      if (!this.filterEnabled) {
        this.request = {
          options: { page: 1, limit: 15, sort: { name: "asc" } },
          query: {},
        };
        this.nameFilter = undefined;
      }
    },

    rightPanelClosed() {
      this.paginate();
      this.$store.dispatch("organizationFirm/resetForm");
    },

    async onReceiverGroupSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationReceiverGroup/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onReceiverGroupSelect(item) {
      if (item && Object.keys(item).length) {
        this.request.query = {
          ...this.request.query,
          receiverGroup: { value: item._id, isObject: true },
        };
      } else {
        this.request.query["receiverGroup"] = null;
        delete this.request.query["receiverGroup"];
      }
    },

    async onAgreementTypeSearch(value, callback) {
      const response = await this.$store.dispatch(`agreementType/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onAgreementTypeSelect(item) {
      if (item && Object.keys(item).length) {
        this.request.query = {
          ...this.request.query,
          "agreementType._id": { value: item._id, isObject: true },
        };
      } else {
        this.request.query["agreementType._id"] = null;
        delete this.request.query["agreementType._id"];
      }
    },

    async onCountrySearch(value, callback) {
      const lang = "tr";
      const response = Countries.filter((x) => x.name[lang].toLowerCase().includes(value.toLowerCase()));
      callback(response);
    },
    onCountrySelect(item) {
      if (item && Object.keys(item).length) {
        this.request.query = {
          ...this.request.query,
          "country.code": { value: item.code, isObject: true },
        };
      } else {
        this.request.query["country.code"] = null;
        delete this.request.query["country.code"];
      }
    },

    //
    async download(item) {
      this.$store.commit("fileManager/addDownloadedFile", { file: item });
    },

    async downloadExcel() {
      // const ok = await this.confirm(this.$t("alert.approve"));
      // if (!ok) {
      //   return;
      // }
      try {
        const { data: file } = await this.$store.dispatch(`organizationFirm/download`);
        this.download(file);

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        console.error(error);
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>

<style scoped>
tr {
  text-align: center;
}
td {
  text-align: center;
}
th {
  vertical-align: middle !important;
}
</style>
